// removed by extract-text-webpack-plugin
module.exports = {"row_table":"components-tjcx-queryStudents-jxQueryStudents-show-row_table-3DLeV","col_left":"components-tjcx-queryStudents-jxQueryStudents-show-col_left-2UniJ","col_right":"components-tjcx-queryStudents-jxQueryStudents-show-col_right-1DN0X","blue":"components-tjcx-queryStudents-jxQueryStudents-show-blue-kGcpZ"};


//////////////////
// WEBPACK FOOTER
// ./components/tjcx/queryStudents/jxQueryStudents/show.css
// module id = 824
// module chunks = 0